import { render, staticRenderFns } from "./PacificOcean.vue?vue&type=template&id=0443fd6a&scoped=true"
import script from "./PacificOcean.vue?vue&type=script&lang=js"
export * from "./PacificOcean.vue?vue&type=script&lang=js"
import style0 from "./PacificOcean.vue?vue&type=style&index=0&id=0443fd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0443fd6a",
  null
  
)

export default component.exports